module.exports = __webpack_public_path__ + "img/icon_coordinates2.e5eff31b.png";